/* eslint-disable no-restricted-globals */
import { history } from "../_helpers";

export const accessEventsServices = {
  applyFilters,
  getAllEventStatus,
  getAllFilters,
  getAllSecurityAudits,
  getSecurityAuditTopCardInfo,
};

function getAllFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const id = "accessEvents";
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/access/events/filter/props`,
    requestOptions
  ).then(handleResponse);
}

function getAllEventStatus() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/fetchDistinctEventStatus`,
    requestOptions
  ).then(handleStatusResponse);
}

function getAllSecurityAudits(offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/access/events/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getSecurityAuditTopCardInfo() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/access/events/cards`,
    requestOptions
  ).then(handleResponse);
}

function applyFilters(user, status, startDate, endDate, search, offset, limit) {
  let users = JSON.parse(localStorage.getItem("user"));
  const sortBy = "DESC";
  const columnName = null;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": users.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify({ user, status, startDate, endDate, search }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/access/events/filter/${limit}/${offset}/${sortBy}/${columnName}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        // location.reload(true);
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleStatusResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        // location.reload(true);
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data.statusValues;
  });
}
